import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=ab3da6ca&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab3da6ca')) {
      api.createRecord('ab3da6ca', component.options)
    } else {
      api.reload('ab3da6ca', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=ab3da6ca&", function () {
      api.rerender('ab3da6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u77omFMFc92s/JS/comp/IncreaseNumber.vue"
export default component.exports